import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  selector: "app-prefix-bc2",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-bc2.component.html",
  styleUrl: "./prefix-bc2.component.less",
})
export class PrefixBc2Component extends PrefixComponent<string> {
  public max: Max;
  public min: Min;
  public commas: number;

  public constructor() {
    super({ updateOn: "blur" });
    this.commas = 0;
    this.min = 0;
    this.max = 99999999;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["bce"];
  }
}
